<template>
  <div v-if="show" class="odp_model">
    <template v-for="(item, index) in table">
      <o-vData
        v-if="item['data']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataMulti
        v-else-if="item['data_multi']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataAfter
        v-else-if="item['data_after']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
    </template>
  </div>
</template>
<script>
import { gain_produce } from "@/seal/proCardSet";

export default {
  name: "baikahe", //白卡盒
  components: {},
  props: {},
  data() {
    return {
      pid: "pidcards_baikahe",
      show: false,
      table: {},
    };
  },
  methods: {
    showChange() {
      // 获取表单
      const produce = gain_produce(this["pid"]);
      if (produce["table"]) {
        this.table = produce["table"];
      } else {
        return;
      }

      this.show = true;
    },
    closeChange() {
      this.show = false;
    },
    //输入框完成事件
    inputChange(event) {
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pid, params);
    },
    //点击产品规格-汇总
    func_SPEC_S(event) {
      const type = event.currentTarget.dataset.type;
      const index = event.currentTarget.dataset.index;
      const seq = event.currentTarget.dataset.seq;
      if (!this.table[index] || !this.table[index][type]) return;
      switch (type) {
        case "data": {
          //当前点击行的所有参数规格
          let data = this.table[index][type];
          if (data[seq]["choose"] && data[seq]["type"] !== "select") return;
          // 点击区域属-'下拉框'
          if (data[seq]["type"] === "select") {
            const select_index = event.currentTarget.dataset.select_index;
            if (select_index) {
              data[seq]["name"] =
                data[seq]["select_data"][select_index]["name"];
              data[seq]["value"] =
                data[seq]["select_data"][select_index]["value"];
            }
          }
          // 切换已选中的'下拉框'的内容时-不需要执行
          if (!data[seq]["choose"]) {
            for (let i in data) {
              if (data[i]["choose"]) {
                data[i]["choose"] = false;
                data[seq]["choose"] = true;
                break;
              }
            }
          }
          if (data[seq].name.indexOf("展开尺寸") >= 0) {
            this.table.p_chengpinchicun["container"] = ["xx", "yy"];
          } else if (data[seq].type == "custom4") {
            this.table.p_chengpinchicun["container"] = ["x", "y", "z"];
          }
          break;
        }
        case "data_multi": {
          const level = event.currentTarget.dataset.level;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (!level) return;

          data[seq]["name"] = data[seq]["select_data"][select_index]["name"];
          data[seq]["value"] = data[seq]["select_data"][select_index]["value"];
          if (level === "1") {
            // 切换二级内容
            data[1]["select_data"] =
              this.table[index]["multi_list"][select_index];
            data[1]["name"] = data[1]["select_data"][0]["name"];
            data[1]["value"] = data[1]["select_data"][0]["value"];
          }
          if (data[seq]["select_data"][select_index]["src"]) {
            this.$parent.func_picture(
              data[seq]["select_data"][select_index]["src"]
            );
          }

          break;
        }
        case "data_after": {
          const se = event.currentTarget.dataset.se;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (data[seq]["must"] && data[seq]["data"][se]["choose"]) return;

          let in_data = data[seq]["data"];

          if (select_index !== undefined) {
            in_data[se]["name"] =
              in_data[se]["select_data"][select_index]["name"];
            in_data[se]["value"] =
              in_data[se]["select_data"][select_index]["value"];
          }

          if (data[seq]["must"]) {
            // 当前行为-必选
            for (let i in in_data) {
              if (in_data[i]["choose"]) {
                in_data[i]["choose"] = false;
                in_data[se]["choose"] = true;
                break;
              }
            }
          } else {
            // 当前行为-非必选
            if (in_data[se]["choose"] && select_index === undefined) {
              in_data[se]["choose"] = false;
            } else {
              for (let i in in_data) {
                if (in_data[i]["choose"]) {
                  in_data[i]["choose"] = false;
                  break;
                }
              }
              in_data[se]["choose"] = true;
            }
          }

          break;
        }
        default: {
          return;
        }
      }

      // 整合规格参数，请求报价
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pid, params);
    },
    // 整理参数
    func_tidyParams() {
      let result = {
        need_QQoffer: true, 
        string: "白卡盒-",
        hjg: [],
        SysCode: "Web",
        pid: 3914,
        qid: 2,
        vid: 0,
        byx: 2.5,
        p: 0,
        gaizi: 0,
        niankoukuan: 15,
        cgst: 15,
        yigai: 47,
        ysfs: 0,
        hedibyx: 2.5,
        shuangmianjiaohen: 1,
        pjxx: 100,
        pjyy: 100,
        pjshuliang: 10000,
        pjbyx: 2.5,
        labelVal: 0,
        prh: 0,
        sjlx: 2,
        hedicailiao: 19,
        hediyongzhi: 190,
        ts: "绳",
        pjcailiao: 2,
        pjyongzhi: 190,
        gvip: null,
        zz: 120,
        kuans: 1,
        zz1: 120,
        houdu_yongzhi: 0.49,
        limianysysName: "单色",
        ysysName: "彩色",
        jphoudu: 1.45,
        hedix: 98,
        hediy: 78,
        hediz: 118,
        hedihoudu_yongzhi: 0.26,
        hediGaoDuWeiZhiWen: 1,
        hedilimianysysName: "彩色",
        hediysysName: "彩色",
        hedishuangmianjiaohen: 1,
        hedihjg: "模切",
        hedijpkezhong: 0,
        hedijphoudu: 1.45,
        ZXid: 0,
        houdu_pjyongzhi: 0.26,
        pjysysName: "彩色",
        pjhjg: "模切",
        labelVal: 0,
        X_TJ_Y: 182,
        X_TJ_Z: 1.5,
        X_TJ_H: 1.5,
        X_TJ_X: 312.0,
        ZhiWenSel: 1,
        limianysys: 1,
        moqieList: 94,
        NHItems: 263,
        jpCl: 1,
        jpHd: 0.45,
        uvCl: 3325,
        tangCl: 2498,
        tangJq: 3410,
        jtCl: 2502,
        jtJq: 3414,
        hediZhiWenSel: 3,
        hediysys: 0,
        hedilimianysys: 1,
        hedisjlx: 2,
        hedits: "绳",
        hedimoqieList: 94,
        hedijpCl: 1,
        hedijpHd: 0.1,
        hediuvCl: 3325,
        heditangCl: 2498,
        hedijtCl: 2502,
        pjmoqieList: 94,
        pjuvCl: 3325,
        pjtangCl: 2498,
        pjjtCl: 2502,
        dtz: 15,
        yinci: 10000,
        cailiaoName: "单铜纸(白卡)",
        dunjia_yongzhi: 4800,
        zhiitem_memo: null,
        xcengSelVal: "0%5E%27%27%5E1%5E0%5E0",
        ywTongBan: 1,
        hedicailiaoName: "单铜纸(白卡)",
        hedidunjia_yongzhi: 5200,
        hedizhiitem_memo: null,
        hedixcengSelVal: "0%5E%27%27%5E1%5E0%5E0",
        isyunshu: 1,
        BAY: 1,
        pjtitle: "纸类配件",
        pjBAY: 1,
        pjCount: 1,
        pjcailiaoName: "单铜纸(白卡)",
        dunjia_pjyongzhi: 5200,
        PJNHItems: 263,
      };

      for (let i in this.table) {
        // 当前行
        const line_name = i;
        // 当前行类型
        let line_type = this.table[i]["data"]
          ? "data"
          : this.table[i]["data_multi"]
          ? "data_multi"
          : this.table[i]["data_after"]
          ? "data_after"
          : false;
        if (!line_type) return;

        const data = this.table[i][line_type];
        switch (line_type) {
          // 面板一(普通)
          case "data": {
            const container = this.table[i]["container"];
            if (!container) return;
            for (let j in data) {
              // 行中选中的块
              if (data[j]["choose"]) {
                // 文字内容提示
                if (line_name === "p_chengpinchicun") {
                  result["string"] +=
                    data[j]["name"] +
                    data[j]["value"][0] +
                    "x" +
                    data[j]["value"][1] +
                    "-";
                } else if (line_name === "p_yinshuashuliang") {
                  result["string"] += data[j]["value"] + "个-";
                } else {
                  result["string"] += data[j]["name"] + "-";
                }

                // 常规处理
                if (container.constructor["name"] === "String") {
                  result[container] = data[j]["value"];
                } else if (container.constructor["name"] === "Array") {
                  for (let c in container) {
                    result[container[c]] = data[j]["value"][c];
                  }
                }
                break;
              }
            }
            break;
          }
          // 面板二(多行)
          case "data_multi": {
            const container = this.table[i]["container"];
            if (!container) return;
            for (let c in container) {
              // 文字内容提示
              result["string"] += data[c]["name"] + "-";

              result[container[c]] = data[c]["value"];
            }
            break;
          }
          // 面板二(后道工序)
          case "data_after": {
            for (let j in data) {
              const in_data = data[j]["data"];
              for (let k in in_data) {
                if (in_data[k]["choose"]) {
                  // 文字内容提示
                  if (
                    in_data[k]["name"] === "烫金" ||
                    in_data[k]["name"] === "烫银" ||
                    in_data[k]["name"] === "局部UV" ||
                    in_data[k]["name"] === "击凸"
                  ) {
                    const x = in_data[k]["value"][0];
                    const y = in_data[k]["value"][1];
                    result["string"] +=
                      in_data[k]["name"] +
                      x +
                      "×" +
                      y +
                      in_data[k]["unit"] +
                      "-";
                  } else if (
                    in_data[k]["name"].substring(0, 1) === "烫" &&
                    in_data[k]["custom2"]
                  ) {
                    const x = in_data[k]["value"][0];
                    const y = in_data[k]["value"][1];
                    result["string"] +=
                      in_data[k]["name"] +
                      x +
                      "×" +
                      y +
                      in_data[k]["unit"] +
                      "-";
                  } else {
                    result["string"] += in_data[k]["name"] + "-";
                  }

                  const container = data[j]["container"];
                  if (!container) return;
                  if (container === "hjg") {
                    result["hjg"].push(in_data[k]["value"]);
                  } else if (container.constructor["name"] === "String") {
                    result[container] = in_data[k]["value"];
                  } else if (container.constructor["name"] === "Array") {
                    for (let c in container) {
                      if (container[c] === "hjg") {
                        result["hjg"].push(in_data[k]["value"][c]);
                      } else {
                        result[container[c]] = in_data[k]["value"][c];
                      }
                    }
                  }
                  break;
                }
              }
            }
            break;
          }
          default:
            return;
        }
      }
      if (result.x && result.y && result.z && result.parentid == 1) {
        result.x = parseInt(result.x);
        result.y = parseInt(result.y);
        result.z = parseInt(result.z);
        result["xx"] = result.x * 2 + result.y * 2 + 15;
        result["yy"] = result.y * 2 + result.z + 30;
      } else if (result.x && result.y && result.z && result.parentid == 8) {
        result.x = parseInt(result.x);
        result.y = parseInt(result.y);
        result.z = parseInt(result.z);
        result["xx"] = result.x * 2 + result.y * 2 + 15;
        result["yy"] = result.y / 2 + result.y + result.z + 35;
      }
      if (result["string"].endsWith("-")) {
        result["string"] = result["string"].substring(
          0,
          result["string"].length - 1
        );
      }
      console.log(result.parentid, result.caitype);
      if (result.parentid == 0 && result.caitype == 1) {
        result.otherparamStr = JSON.stringify({
          niankoukuan: "15",
          cgst: "15",
          yigai: "40",
        });
        result.FuID = 3;
      } else if (result.parentid == 0 && result.caitype == 2) {
        result.otherparamStr = JSON.stringify({
          niankoukuan: "15",
          cgst: "15",
          yigai: "40",
          sbxkg: "15",
          xbxkg: "15",
        });
        result.FuID = 3;
      } else if (result.parentid == 0 && result.caitype == 3) {
        result.otherparamStr = JSON.stringify({
          tongYiNianKouWei: 1,
          niankoukuan: "15",
          cgst: "15",
          yigai: "40",
          ggzg: "30",
          gaicha: "15",
        });
        result.FuID = 3;
      } else if (result.parentid == 0 && result.caitype == 5) {
        result.otherparamStr = JSON.stringify({
          tongYiNianKouWei: 1,
          niankoukuan: "15",
          cgst: "15",
          yigai: "40",
        });
        result.FuID = 3;
      } else if (result.parentid == 1 && result.caitype == 8) {
        result.otherparamStr = JSON.stringify({
          tongYiNianKouWei: 1,
          niankoukuan: "15",
          cgst: "15",
          yigai: "40",
          kdcr: "20",
        });
        result.FuID = 2;
      } else if (result.parentid == 1 && result.caitype == 9) {
        result.otherparamStr = JSON.stringify({
          tongYiNianKouWei: 1,
          niankoukuan: "15",
          cgst: "15",
          yigai: "40",
          kdcr: "20",
          bxkg: "20",
        });
        result.FuID = 2;
      } else if (result.parentid == 1 && result.caitype == 10) {
        result.otherparamStr = JSON.stringify({
          tongYiNianKouWei: 1,
          niankoukuan: "15",
          cgst: "15",
          yigai: "40",
          kdcr: "20",
          ggzg: "30",
        });
        result.FuID = 2;
      } else if (result.parentid == 1 && result.caitype == 26) {
        result.otherparamStr = JSON.stringify({
          tongYiNianKouWei: 1,
          niankoukuan: "15",
          cgst: "15",
          yigai: "16",
          kdcr: "20",
        });
        result.FuID = 2;
      }
      result.materialname = this.table.p_cailiao.data_multi[0].name;

      return result;
    },
  },
  mounted() {},
};
</script>
<style src='@/style/orderProduct.css'></style>




// WEBPACK FOOTER //
// src/pages/order/v2020/baikahe.vue